import type { ReactNode } from "react";

import type { DesignSystemElementProps, DesignSystemRef } from "@/design-system/contracts/dom";

export type ActivityDetailsProps = {
  children: ReactNode;
} & DesignSystemElementProps<"div"> &
  DesignSystemRef<HTMLDivElement>;

/** Responsive label/value facts inside an activity message. Uses the nearest existing container boundary. */
export function ActivityDetails({ children, ref, ...nativeProps }: ActivityDetailsProps): ReactNode {
  return (
    <div
      {...nativeProps}
      ref={ref}
      className="grid items-center gap-x-space-md gap-y-space-xs not-italic @xs:grid-cols-3 @xs:gap-y-space-sm"
    >
      {children}
    </div>
  );
}

export type ActivityDetailLabelProps = {
  children: ReactNode;
} & DesignSystemElementProps<"span"> &
  DesignSystemRef<HTMLSpanElement>;

export function ActivityDetailLabel({ children, ref, ...nativeProps }: ActivityDetailLabelProps): ReactNode {
  return (
    <span {...nativeProps} ref={ref} className="mt-space-sm text-body-emphasis @xs:col-span-1 @xs:mt-0 @xs:text-body">
      {children}
    </span>
  );
}

export type ActivityDetailValueProps = {
  children: ReactNode;
} & DesignSystemElementProps<"span"> &
  DesignSystemRef<HTMLSpanElement>;

export function ActivityDetailValue({ children, ref, ...nativeProps }: ActivityDetailValueProps): ReactNode {
  return (
    <span {...nativeProps} ref={ref} className="@xs:col-span-2">
      {children}
    </span>
  );
}

export function ActivityDetailRemark({ children, ref, ...nativeProps }: ActivityDetailValueProps): ReactNode {
  return (
    <span {...nativeProps} ref={ref} className="italic @xs:col-span-2">
      {children}
    </span>
  );
}
